<template>
  <GeneralDashboardLayout>
   
    <template v-slot:header>
      <div class="header-template">
        <BackButton :to="{ name: 'event_dashboard.index' }" />
        <h1 class="title text-center">Event Dashboard</h1>
            
      </div>
   
    </template>
    <template v-slot:content>
      <div class="dashboard-content">
        <div class="container-fluid">
          <section class="card mt-2">
            <header class="card-header">
              <h3 class="mt-0 mt-0 text-center">Event Games</h3>
          
            </header>
            <div class="card-body">
              <div class="row show-grid justify-content-md-center">
                <div class="event_features" v-if="item._id">
                  <RouterLink :to="{name: 'trivia_game.index', params: {event_id: item._id}}" >
                    <span class="feature_box">
                      <img src="/assets/images/dashboard_event/Event_Theme_Settings.png" class="asset_img" alt="logo">
                      <span>Trivia Game</span>
                    </span> <!---->
                  </RouterLink>

        


                
                  <!---->
                   <!---->
                </div>
              </div>
            </div>
          </section>
         
        </div>
      </div>
    </template>
  </GeneralDashboardLayout>
  <FlashMessage group="event_games_dashboard" />

</template>

<script>
import {mapActions, mapGetters} from "vuex";
import GeneralDashboardLayout from "@/components/layouts/GeneralDashboardLayout";
import { isPermits} from "@/services/CheckPermissions";
import BackButton from "@/components/Commons/BackButton";
export default {
  name: "OrganizerDashboardIndex",
  components: {GeneralDashboardLayout,BackButton},
  data() {
    return {
    }
  },
  beforeUnmount() {
    delete this.$flashMessage.groups.event_games_dashboard;
    
  },
  computed: {
    ...mapGetters("AuthenticationsIndex",{checkPermssions:"all", role:"role"}),
 
    ...mapGetters("EventsSingle", [
      "item",
      "loading",
    ])
  },
  created() {
    //this.fetchPermissions();
    this.verifyPermissions(this.$route.params.event_id)
    this.fetchData(this.$route.params.event_id)
    console.log('process.env', process.env)
  },
  methods: {
    ...mapActions("AuthenticationsIndex",["fetchPermissions","verifyPermissions"]),
    ...mapActions("EventsSingle", ['fetchData']),
    can(permit,permissions){
      return isPermits(permit,permissions);
    }
  }
}
</script>

<style scoped lang="scss">
.header {
  color: white;
  background: linear-gradient(90deg, #0058dd, #20abe6);
  min-height: 30px;

  h1 {
    text-align: center;
    font-size: 22px;
    padding: 0;
    margin: 16px 0 0 0;
  }
}

.dashboard-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.event_features {
  max-width: 700px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;

  a {
    text-decoration: none;
    margin-right: 15px;
  }

  .feature_box {
    padding: 15px 5px;
    box-shadow: 0px 0px 4px #ccc;
    width: 135px;
    display: grid;
    text-align: center;
    margin-bottom: 15px;
    max-height: 150px;
    min-height: 150px;
    overflow: hidden;
    word-break: break-word;
    background: linear-gradient(300deg, #094ac0, #1faae6);
    color: white;
    font-weight: 500;
    border-radius: 10px;

    span:nth-child(2) {
      line-height: 20px;
      vertical-align: middle;
    }

    a:nth-child(5) > .feature_box {
      margin-right: 0px;
    }
  }

  .feature_box:hover {
    background: linear-gradient(300deg, #34496f, #8ea9b4);
  }
}

.asset_img {
  display: block;
  margin: 0 auto;
  max-width: 84px;
}

.events-select-main {
  position: relative;

  button {
    border: none;
    color: white;
    background: linear-gradient(300deg, #135cba, #5aa0c2);
    padding: 8px 24px;
  }

  .list {
    top: 22px;
    width: 100%;
    min-width: 100px;
    background-color: white;
    border: 10px;
    box-shadow: 0px 0px 4px #ccc;

    .item {
      background-color: white;
      padding: 3px 12px;

      a {
        color: black;
        font-size: 16px;
        font-weight: bold;
      }

      &:hover {
        background-color: #ebebeb;
      }
    }

    .item:nth-child(2n) {
      background-color: #d5d5d5;
    }
  }
}

.bx {
  font-size: 5em;
  display: block;
  height: 80px;
}

.sel_event_type {
  background: linear-gradient(300deg, #094ac0, #1faae6);
  color: #ffffff;
  width: 200px;
  option {
    color: black
  }
}

.sel_event_type:after {
  content: '\f078';
  font: normal normal normal 17px/1 FontAwesome;
  color: #0ebeff;
  right: 11px;
  top: 6px;
  height: 34px;
  padding: 15px 0px 0px 8px;
  border-left: 1px solid #0ebeff;
  position: absolute;
  pointer-events: none;
}
</style>